import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import Vue from 'vue';
import Router from 'vue-router';
import Axios from "axios";
import store from "./store";
import loginTool from "./loginTool";
import { getLoginAuth, clearLoginAuth } from '@/config/loginAuth';
var Login = function Login() {
  return import("../components/Login.vue");
};
var Err404 = function Err404() {
  return import("../components/Err404.vue");
};
var MainComponent = function MainComponent() {
  return import("../components/Index.vue");
};
var TrialSheet = function TrialSheet() {
  return import("../components/TrialSheet.vue");
};
var TrialSheetReview = function TrialSheetReview() {
  return import("../components/TrialSheetReview.vue");
};
var SNSList = function SNSList() {
  return import("../components/SNSList.vue");
};
var UserManage = function UserManage() {
  return import("../components/UserManage.vue");
};
var UserList = function UserList() {
  return import("../components/UserList.vue");
};
var GroupList = function GroupList() {
  return import("../components/GroupList.vue");
};
var ProductManage = function ProductManage() {
  return import("../components/ProductManage.vue");
};
var ProductList = function ProductList() {
  return import("../components/ProductList.vue");
};
var ProductDetailList = function ProductDetailList() {
  return import("../components/ProductDetailList.vue");
};
var Tool = function Tool() {
  return import("../components/Tool.vue");
};
var ToolCommon = function ToolCommon() {
  return import("../components/ToolCommon.vue");
};
var ToolOSS = function ToolOSS() {
  return import("../components/ToolOSS.vue");
};
var ToolOSSList = function ToolOSSList() {
  return import("../components/ToolOSSList.vue");
};
Vue.use(Router);
var router = new Router({
  routes: [{
    path: "/",
    redirect: "/login"
  }, {
    path: "/login",
    component: Login,
    name: "Login"
  }, {
    path: "/err404",
    component: Err404
  }, {
    path: "/module",
    component: MainComponent,
    name: "Module",
    children: [{
      path: "/module/trialsheet",
      component: TrialSheet,
      name: "TrialSheet",
      meta: {
        name: "申请试用",
        auths: ["submit_trial_request"]
      }
    }, {
      path: "/module/trialsheetreview",
      component: TrialSheetReview,
      name: "TrialSheetReview",
      meta: {
        name: "试用审核",
        auths: ["admin_review_request"]
      }
    }, {
      path: "/module/sns",
      component: SNSList,
      name: "SNSList",
      meta: {
        name: "授权管理",
        auths: ["dev_activate"]
      }
    }, {
      path: "/module/user",
      component: UserManage,
      name: "UserManage",
      meta: {
        name: "用户管理",
        auths: {
          list: ["admin_manage_users", "admin_manage_groups"],
          limit: "some"
        }
      },
      children: [{
        path: "/module/user/list",
        component: UserList,
        name: "UserList",
        meta: {
          name: "用户列表",
          auths: ["admin_manage_users"]
        }
      }, {
        path: "/module/user/groups",
        component: GroupList,
        name: "UserGroupList",
        meta: {
          name: "角色管理",
          auths: ["admin_manage_groups"]
        }
      }]
    }, {
      path: "/module/product",
      component: ProductManage,
      name: "ProductManage",
      meta: {
        name: "产品管理"
      },
      children: [{
        path: "/module/product/configs",
        component: ProductList,
        name: "ProductConfigs",
        meta: {
          name: "产品配置",
          auths: ["dev_product_configs"]
        }
      }, {
        path: "/module/product/details",
        component: ProductDetailList,
        name: "ProductDetailList",
        meta: {
          name: "产品明细"
        }
      }]
    }, {
      path: "/module/tool",
      component: Tool,
      name: "Tool",
      meta: {
        name: "系统工具"
      },
      children: [{
        path: "/module/tool/common",
        component: ToolCommon,
        name: "ToolCommon",
        meta: {
          name: "常用工具"
        }
      }, {
        path: "/module/tool/oss",
        component: ToolOSS,
        name: "oss",
        meta: {
          name: "OSS工具",
          auths: ["oss_tools"]
        }
      }, {
        path: "/module/tool/ossList",
        component: ToolOSSList,
        name: "ossList",
        meta: {
          name: "OSS日志",
          auths: ["oss_tools"]
        }
      }]
    }]
  }]
});
router.beforeEach(function (to, from, next) {
  var isLogin = getLoginAuth() !== null;
  if (to.path === "/login") {
    if (from.matched.length > 0) {
      location.href = location.href.replace(/#.*$/, '');
      return false;
    }

    // 凡是去登录，且没有清除过 后端身份验证、前端登录凭证，都清除一遍
    // 防止 用户输入地址手动跳转至登录 或 前进后退 等异常跳转情况
    // 比如，用户跳转至登录，再点后退，相当于刷新至该页面
    // 前端无法操作cookie里的session，只能这样补救
    // 但是！！！如果logout失败，漏洞还会在
    if (isLogin) {
      Axios.delete("users/auth/").then(function () {
        clearLoginAuth();
      });
    }
    next();
    return false;
  }

  // 只对'/module'开头的路径鉴权
  if (!/^\/module/.test(to.path)) {
    next();
    return false;
  }

  // 登录鉴权
  var userInfo = store.state.user;
  if (userInfo === null) {
    // vuex没有登录信息，本地也没有登录凭证，直接退出
    if (!isLogin) {
      next('/login');
      return false;
    }

    // vuex没有登录信息，本地保存有登录凭证，尝试获取登录信息
    Axios.get("users/current-user/").then(function (resp) {
      var _resp$data = resp.data,
        code = _resp$data.code,
        user = _resp$data.user;
      if (code === 0 && user !== null) {
        var _loginTool$getLoginIn = loginTool.getLoginInfo(user),
          authHash = _loginTool$getLoginIn.authHash,
          _menuHash = _loginTool$getLoginIn.menuHash;
        store.commit('updateLoginInfo', {
          user: user,
          authHash: authHash,
          menuHash: _menuHash
        });

        // 如果用 next() 会直接进入页面
        // 用 next(to.path)，多走一遍 beforeEach，进入下面的 菜单鉴权 && 激活菜单确定
        next(to.path);
        return false;
      }
      location.href = location.href.replace(/#.*$/, '');
      return false;
    }, function (err) {
      console.log('router err', err);
      location.href = location.href.replace(/#.*$/, '');
    });
    return false;
  }

  // 菜单鉴权 && 激活菜单确定
  var menuHash = store.state.menuHash;
  var menu = menuHash[to.name];
  if (!menu) {
    // 没有路由 或 没有权限，总之不可访问
    next("/err404");
    return false;
  }
  if (menu.redirect) {
    next(menu.redirect);
    return false;
  }
  next();
});
export default router;